import gql from 'graphql-tag';

import client from '../graphqlAPI';

// The campaign selection matches getEmailCampaignsList's row shape exactly, so the
// caller can drop the returned campaign straight into the list without refetching.
// Keep the two in step: a field added there and missed here shows as undefined on
// precisely one row - the one the user just made.
const CREATE_EMAIL_CAMPAIGN_MUTATION = gql`
  mutation createEmailCampaign($key: String!, $title: String!, $kind: String!) {
    createEmailCampaign(key: $key, title: $title, kind: $kind) {
      isAuth
      success
      error
      campaign {
        key
        title
        kind
        isActive
        templateCount
        inactiveCount
        hasAnyTemplate
        createdAt
        languages {
          language
          status
        }
      }
    }
  }
`;

const createEmailCampaign = async ({ key, title, kind }) => {
  try {
    const result = await client
      .mutate({
        mutation: CREATE_EMAIL_CAMPAIGN_MUTATION,
        variables: { key, title, kind },
        fetchPolicy: 'no-cache',
      })
      .then(mutationResult => mutationResult)
      .catch((mutationError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Mutation Error: ${mutationError}`);
        return null;
      });

    const { data: { createEmailCampaign: createEmailCampaignData } } = result;

    if (createEmailCampaignData) return createEmailCampaignData;

    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Mutation Error: createEmailCampaignData = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: createEmailCampaign Error: ${error}`);
    return null;
  }
};

export default createEmailCampaign;
